<template>
    <div class="table-wrapper cover-content project-list">
        <!-- <high-search>  -->
            <Form ref="formInline" :model="formInline" inline class="form-list"
                  :label-width="100" label-position="right">
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="项目名称:" prop="projectName" :label-width="78">
                            <Input v-model="formInline.projectName" placeholder="请输入项目名称"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="建设单位:" prop="buildCorpName">
                            <Input v-model="formInline.buildCorpName" placeholder="请输入建设单位"></Input>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="实名制情况:" prop="regState">
                            <RadioGroup v-model="formInline.regState">
                                <Radio :label="-1">全部</Radio>
                                <Radio :label="1">已上传实名数据</Radio>
                                <Radio :label="0">未上传实名数据</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="4" class="high-search">
                        <Button type="primary" @click="handleQuery">搜索</Button>
                        <Button style="margin-left: 20px" @click="handleReset">重置</Button>
                        <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span>
                    </Col>
                </Row>
                <Row :gutter="16" v-show='open'>
                    <Col span="6">
                        <FormItem label="项目状态:" prop="prjStatus" :label-width="78">
                            <Select v-model="formInline.prjStatus" clearable placeholder="请选择项目状态">
                                <Option v-for="(item,index) in projectStatus" :value="item.code" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="项目分类：" prop="category">
                            <Select v-model="formInline.category" clearable placeholder="请选择项目分类">
                                <Option v-for="(item,index) in projectCatetory" :value="item.code" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="施工单位：" prop="winUnit">
                            <Input v-model="formInline.winUnit" placeholder="请输入施工单位"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="开工时间：" prop="WorkTime">
                            <DatePicker type="daterange" split-panels placeholder="请选择开始结束时间" :value="formInline.WorkTime" @on-change="formInline.WorkTime=$event" transfer></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16" v-show='open'>
                    <Col span="6">
                        <FormItem label="项目所在地:" :label-width="78">
                            <place-select v-model="formInline.areaCode"></place-select>
                            <!--<Select v-model="areaCode">-->
                                <!--<Option v-for="item in area" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
                            <!--</Select>-->
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="施工许可证办理情况：" prop="buildNumFlag">
                            <Select v-model="formInline.buildNumFlag" clearable placeholder="请选择项目分类">
                                <Option :value="0">全部</Option>
                                <Option :value="1">已办理施工许可证</Option>
                                <Option :value="2">正在办理施工许可证</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="开工报告办理情况：" prop="startReportFlag">
                            <Select v-model="formInline.startReportFlag" clearable placeholder="请选择项目分类">
                                <Option :value="0">全部</Option>
                                <Option :value="1">已办理开工报告</Option>
                                <Option :value="2">正在办理开工报告</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="施工许可证号：" prop="builderLicenseNum">
                            <Input v-model="formInline.builderLicenseNum" placeholder="请输入施工许可证号"></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        <!-- </high-search> -->
        <Table border :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
            <template slot-scope="{ row, index }" slot="buildNumFlag">
                <div v-if="row.buildNumFlag == 1">已办理施工许可证</div>
                <div v-else>正在办理施工许可证</div>
            </template>
            <template slot-scope="{ row, index }" slot="startReportFlag">
                <div v-if="row.buildNumFlag != 1 && row.startReportFlag == 1">已办理开工报告</div>
                <div v-if='row.buildNumFlag != 1 && row.startReportFlag != 1'>正在办理开工报告</div>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <span class="pointer" style="margin-right: 8px" @click="handleDeal('projectMainForm',row.projectId)">编辑</span>
                <span class="pointer" @click="handleDeal('projectMainDetail',row.projectId)">详情</span>
                <span v-if="row.regState === '未上传实名数据' && $route.name === 'projectMaintaining'" style="margin-left: 8px" class="pointer" @click="handleDelete(row.projectId)">删除</span>
            </template>
        </Table>
        <div class="t-page">
            <Page :total="totalCount" :page-size="pageSize" :current="page"
                  @on-change="changePage" @on-page-size-change="pageSizeChange"
                  show-elevator show-sizer show-total transfer>
            </Page>
        </div>
    </div>
</template>
<script>
    import {mapState,mapGetters} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                open: false,
                formInline:{
                    builderLicenseNum: '',
                    areaCode: localStorage.getItem('tenantAreaCode'),
                    //项目名称：
                    projectName:'',
                    //项目分类：
                    category:'',
                    //施工单位：
                    winUnit:'',
                    //建设单位：
                    buildCorpName:'',
                    //项目状态：
                    prjStatus:'',
                    //开工开始时间:
                    startWorkTimeStart:'',
                    //开工结束时间：
                    startWorkTimeEnd:'',
                    //实名制状态：
                    regState: -1,
                    WorkTime:[],
                    //施工许可证办理情况 0全部1已办理2正在办理
                    buildNumFlag: 0,
                    startReportFlag: 0
                },
                tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '项目名称',
                        key: 'projectName',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '项目状态',
                        key: 'prjStatus',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '项目类别',
                        key: 'category',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '行政区划',
                        key: 'areaName',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '实名制数据对接情况',
                        key: 'regState',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '施工许可证办理情况',
                        slot: 'buildNumFlag',
                        minWidth:100,
                        tooltip: true
                    },
                    { title: "施工许可证号", key: 'builderLicenseNum', minWidth: 210, tooltip: true },
                    {
                        title: '开工报告办理情况',
                        slot: 'startReportFlag',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '开工时间',
                        key: 'startDate',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '竣工时间',
                        key: 'completeDate',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '建设单位',
                        key: 'buildCorpName',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '施工单位',
                        key: 'contractorCorpName',
                        minWidth:100,
                        tooltip: true
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        width: 150,
                    }
                ],
                tableData:[],
                exportData:{}
            };
        },
        computed:{
            ...mapState([ 'area']),
            ...mapGetters(['projectStatus','projectCatetory']),
        },
        created(){
            this.$route.query.areaCode && (this.formInline.areaCode = this.$route.query.areaCode)
            this.formInline.regState = this.$route.query.regState ? this.$route.query.regState : -1;
            this.formInline.prjStatus = this.$route.query.prjStatus ? this.$route.query.prjStatus : ''
        },
        mounted(){

        },
        watch: {
        },
        methods: {
            /*处理操作*/
            handleDelete(projectId){
                this.$Modal.confirm({
                    title: '提示',
                    content: `确定要删除该项吗？`,
                    onOk: () => {
                        this.axios({
                            method: 'delete',
                            url: `/project/delete/${projectId}`,
                            data: {}
                        }).then((res) => {
                            if (res.data.success) {
                                this.$Message.success({
                                    content: '操作成功'
                                })
                                this.getTableData()
                            } else {
                                this.$Message.warning({
                                    content: '操作失败'
                                })
                            }
                        })
                    },
                    onCancel: () => {
                    }
                });
            },
            handleReset () {
                this.formInline = {
                    areaCode : localStorage.getItem('tenantAreaCode'),
                    //项目名称：
                    projectName:'',
                    //项目分类：
                    category:'',
                    //施工单位：
                    winUnit:'',
                    //建设单位：
                    buildCorpName:'',
                    //项目状态：
                    prjStatus:'',
                    //开工开始时间:
                    startWorkTimeStart:'',
                    //开工结束时间：
                    startWorkTimeEnd:'',
                    //实名制状态：
                    regState:-1,
                    WorkTime:[],
                    //施工许可证办理情况 0全部1已办理2正在办理
                    buildNumFlag: 0,
                    startReportFlag: 0,
                    builderLicenseNum: ''
                }
                this.getTableData();
            },
            //导出
            handleExport(){
                let param={
                    size:this.pageSize,
                    current:this.page,
                };
                this.formInline.startWorkTimeStart=this.formInline.WorkTime[0];
                this.formInline.startWorkTimeEnd=this.formInline.WorkTime[1];
                Object.assign(param,this.formInline);
                delete param.WorkTime;
                this.axios({
                    method: 'post',
                    url:'/project/export',
                    responseType:'arraybuffer',
                    data: param,
                }).then( (response)=> {
                    this.common.download(response,'项目数据.xls','application/vnd.ms-excel');
                });
            },
            /*处理操作*/
            handleDeal(name,projectId){
                this.$router.push({
                    name: name,
                    query: {
                        projectId:projectId
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    size:this.pageSize,
                    current:this.page,
                };
                this.formInline.startWorkTimeStart=this.formInline.WorkTime[0];
                this.formInline.startWorkTimeEnd=this.formInline.WorkTime[1];
                Object.assign(param,this.formInline);
                delete param.WorkTime;
                this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/project/pageList',
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total;
                        this.tableData=response.data.data.records;
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
